import React from 'react'
import { useIntl, Link } from 'gatsby-plugin-intl'
import Layout from '../../components/Layout/index'
import Header from '../../modules/Header'
import Footer from '../../modules/Footer'
import SEO from '../../components/seo'
import PressRelease from '../../components/PressRelease'

import messages from '../../messages/pageTitles.lang'
import metaDescription from '../../messages/pageMetaDescriptions.lang'
import Image from '../../images/news/HHT-Budgetmeldung_1_1_en.jpg'
import ImageDE from '../../images/news/HHT-Budgetmeldung_1_1_de.jpg'

import { newsList } from '../../components/NewsPage/data'

const IndexPage = () => {
  const { formatMessage, locale } = useIntl()

  return (
    <Layout footer={<Footer />} header={<Header withTeaser />}>
      <SEO
        title={formatMessage(messages.TitleHamburgTourism)}
        imageAlt={formatMessage(messages.TitleHamburgTourism)}
        description={formatMessage(metaDescription.NewsHamburgTourismDescription)}
        image={locale === 'de' ? ImageDE : Image}
        lang={locale}
      />
      <PressRelease
        article={newsList.hamburgTourism}
        articleLinks={{
          tsbo: (
            <Link to="/products/quickstart/">
              TravelSandbox®
            </Link>
          )
        }}
      />
    </Layout>
  )
}

export default IndexPage
